export function vocabularyGrade(card = {}) {
  if (card.completionReason === 'complete') return 5;
  return Math.max(0, Math.min(5, Math.floor(Number(card.grade) || 0)));
}

// A terminal reason describes how study ended; it must not promote the score
// or the learning grade just to display the matching existing graduation stamp.
export function vocabularyGraduationType(card = {}) {
  if (card.completionReason === 'already_known') return 'early';
  if (card.completionReason === 'user_canceled') return 'manual';
  if (vocabularyGrade(card) === 5) return 'score';
  return null;
}

export function vocabularyLearningStatus(card = {}) {
  if (card.completionReason === 'user_canceled') return 'excluded';
  if (card.completionReason === 'already_known' || vocabularyGrade(card) === 5) return 'completed';
  return card.isNew === false || card.firstAppearanceId || card.lastStudiedDay || vocabularyGrade(card) > 0
    ? 'learning' : 'unlearned';
}

export function buildVocabularyProgressCounts(cards = []) {
  return cards.reduce((counts, card) => {
    const status = vocabularyLearningStatus(card);
    if (status === 'excluded') return counts;
    counts[status] += 1;
    counts.total += 1;
    return counts;
  }, { completed: 0, learning: 0, unlearned: 0, total: 0 });
}
